import { useTranslation } from 'react-i18next'
import { useStyletron } from 'baseui'
import { ChevronLeft, ChevronRight } from 'baseui/icon'
import { tooltipOverrides } from '@/hoc/SidebarMenu/styled-components'
import { useRightPanel } from './rightPanelContext'

const useRightPanelToggle = () => {
  const { t } = useTranslation()
  const [, theme] = useStyletron()
  const { expanded, toggle } = useRightPanel()

  return {
    expanded,
    onToggle: toggle,
    Icon: expanded ? ChevronRight : ChevronLeft,
    iconColor: theme.colors.primary,
    label: t(expanded ? 'common:collapse_panel' : 'common:expand_panel'),
    tooltipOverrides: tooltipOverrides(),
  }
}

export default useRightPanelToggle
